import { z } from "zod";
import i18n from "./i18n";

/**
 * QA 29/10: mensagens padrão do Zod vinham em inglês ("Required", "Invalid email"...) em
 * login, cadastro e inscrição, porque o errorMap em português só era aplicado quando o
 * formulário de lead carregava. Este mapa é global (carregado no main.tsx) e usa o i18n,
 * com pt-BR como padrão. Mensagens definidas no schema continuam valendo.
 */
const tr = (key: string, defaultValue: string, opts?: Record<string, unknown>) =>
  i18n.t(`zodErros.${key}`, { defaultValue, ...opts }) as string;

export const zodErrorMapPtBr: z.ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === "undefined" || issue.received === "null") {
        return { message: tr("obrigatorio", "Campo obrigatório") };
      }
      return { message: tr("tipoInvalido", "Valor inválido") };
    case z.ZodIssueCode.too_small:
      if (issue.type === "string") {
        if (Number(issue.minimum) <= 1) return { message: tr("obrigatorio", "Campo obrigatório") };
        return { message: tr("minimoCaracteres", "Deve ter pelo menos {{n}} caracteres", { n: issue.minimum }) };
      }
      if (issue.type === "array") {
        return { message: tr("minimoItens", "Selecione pelo menos {{n}} opção(ões)", { n: issue.minimum }) };
      }
      return { message: tr("minimoValor", "Deve ser no mínimo {{n}}", { n: issue.minimum }) };
    case z.ZodIssueCode.too_big:
      if (issue.type === "string") {
        return { message: tr("maximoCaracteres", "Deve ter no máximo {{n}} caracteres", { n: issue.maximum }) };
      }
      return { message: tr("maximoValor", "Deve ser no máximo {{n}}", { n: issue.maximum }) };
    case z.ZodIssueCode.invalid_string:
      if (issue.validation === "email") return { message: tr("emailInvalido", "E-mail inválido") };
      if (issue.validation === "url") return { message: tr("urlInvalida", "Link inválido") };
      return { message: tr("formatoInvalido", "Formato inválido") };
    case z.ZodIssueCode.invalid_date:
      return { message: tr("dataInvalida", "Data inválida") };
    case z.ZodIssueCode.invalid_enum_value:
      return { message: tr("opcaoInvalida", "Selecione uma opção válida") };
    case z.ZodIssueCode.custom:
      return { message: tr("valorInvalido", "Valor inválido") };
    default:
      return { message: ctx.defaultError };
  }
};

z.setErrorMap(zodErrorMapPtBr);
